<div class="relative">
  <!-- Overlay -->
  <div
    class="fixed inset-0 bg-black bg-opacity-50 z-9998 transition-opacity duration-300 opacity-0 pointer-events-none"
    [ngClass]="{ 'opacity-70 pointer-events-auto': isSidebarOpen, 'opacity-0 pointer-events-none': !isSidebarOpen }">
  </div>

  <!-- Sidebar -->
  <div
    class="overflow-auto fixed top-0 right-0 z-9999 h-full translate-x-full bg-white shadow-xl transform transition-transform duration-300 ease-in-out"
    [ngStyle]="{'width': sidebarWidth + '%'}"
    [ngClass]="{ 'translate-x-0': isSidebarOpen, 'translate-x-full': !isSidebarOpen }">

    <!-- Resize Handle -->
    <div
      class="absolute top-0 left-0 w-4 h-full cursor-ew-resize hover:bg-gray-200 hover:bg-opacity-50 flex items-center justify-center touch-none sm:w-2"
      (mousedown)="startResize($event)"
      (touchstart)="startResize($event)">
      <div class="w-1 h-20 rounded-full bg-gray-300 sm:h-20"></div>
    </div>

    <!-- Close Button -->
    <button
      class="absolute top-4 right-4 text-gray-500 hover:text-gray-700 focus:outline-none"
      (click)="closeSidebar()">
      <lucide-icon [name]="XIcon" size="24"></lucide-icon>
    </button>
    <div class="p-4 pl-8 sm:pl-6">
      <ng-content></ng-content>
    </div>
  </div>
</div>
